export default __webpack_public_path__ + "static/media/upper-back-img.4a598813.png";